import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import { Grid } from '@material-ui/core';
import FrameBase from '../FrameBase';
import BlockPrompt from '../../form/BlockPrompt';
import FrameToolbar from '../FrameToolbar';
import { DEFAULT_STATUS_VALUES } from '../../formatter/job/JobStatus';

var getUrl = function getUrl(projectName, projectUid, jobId, contactId, hideFormNavigation, previewPath) {
  var jobIdParam = jobId ? "&jobId=".concat(jobId) : '';
  var projectParam = projectUid ? "uid=".concat(projectUid) : "name=".concat(encodeURIComponent(projectName));
  var contactIdParam = contactId ? "&ContactId=".concat(contactId) : '';
  var hideNavigationParm = hideFormNavigation ? '&hideNavigation=true' : '';
  var previewPathParam = previewPath ? "&previewPath=".concat(encodeURIComponent(previewPath)) : '';
  return "/Embed/Run?".concat(projectParam).concat(jobIdParam).concat(contactIdParam).concat(hideNavigationParm).concat(previewPathParam);
};

var COMMUNICATION_STATUS_VALUES = _objectSpread({}, DEFAULT_STATUS_VALUES, {
  WaitingForInput: 'Draft',
  Starting: 'In Progress',
  WaitingForSignature: 'In Progress'
});

var getStatus = function getStatus(jobStage) {
  return COMMUNICATION_STATUS_VALUES[jobStage] || 'Draft';
};
/**
 * @extends {React.Component<import('./types').CommunicationFrameProps>}
 */


var CommunicationFrame =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CommunicationFrame, _React$Component);

  function CommunicationFrame(props) {
    var _this;

    _classCallCheck(this, CommunicationFrame);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CommunicationFrame).call(this, props));
    _this.frame = React.createRef();
    _this.callbackContext = {};

    _this.callback = function (cb) {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      return cb.apply(void 0, [_this.callbackContext].concat(rest));
    };

    _this.save = function () {
      return _this.frame.current.send('Save');
    };

    _this.submit = function () {
      if (_this.props.onBeforeSubmit && !_this.props.onBeforeSubmit()) return;
      return _this.frame.current.send('Submit');
    };

    _this.getData = function () {
      return _this.frame.current.sendPromise('GetFormData');
    };

    _this.updateFields = function (options) {
      return _this.frame.current.sendPromise('UpdateFields', options);
    };

    _this.triggerValidation = function () {
      if (_this.props.onBeforeSubmit && !_this.props.onBeforeSubmit()) return Promise.resolve(false);
      return _this.frame.current.sendPromise('ValidateForm');
    };

    _this.changePreviewTemplate = function (path) {
      _this.frame.current.send('ChangeTemplate', {
        path: path
      });
    };

    _this.uploadFormData = function (formData) {
      _this.frame.current.send('UploadFormData', {
        formData: formData
      });
    };

    _this.getToolbarProps = function (toolbarProps) {
      var jobId = _this.props.jobId;
      var _this$state = _this.state,
          status = _this$state.status,
          submitting = _this$state.submitting,
          submitted = _this$state.submitted,
          saving = _this$state.saving,
          dirty = _this$state.dirty;
      /** @type {import('core/Icon/types').IconProps} */

      var saveIcon = {
        type: saving ? 'loading' : 'save',
        label: saving ? 'Saving' : 'Save',
        hoverable: true,
        onClick: _this.save,
        disabled: submitting || submitted || saving || !dirty && !!jobId
      };
      /**@type {import('core/Button/types').ButtonProps} */

      var submitButton = {
        children: submitting ? 'Finalizing...' : 'Finalize',
        disabled: submitting || submitted || saving,
        onClick: _this.submit
      };
      var crtToolbarProps = {
        title: status,
        icons: [saveIcon],
        button: submitButton
      };
      if (typeof toolbarProps === 'undefined') return crtToolbarProps;

      if (typeof toolbarProps === 'object') {
        if (toolbarProps.title) crtToolbarProps.title = toolbarProps.title;
        if (toolbarProps.icons) throw new Error('toolbarProps.icons not implemented');

        if (toolbarProps.button) {
          crtToolbarProps.button = _objectSpread({}, crtToolbarProps.button, toolbarProps.button);

          if (toolbarProps.button.onClick) {
            //custom submit onClick action
            crtToolbarProps.button.onClick = function (e) {
              _this.onEvent({
                action: 'Submit'
              });

              var returnedValue = toolbarProps.button.onClick(e);

              if (returnedValue && returnedValue.then) {
                return returnedValue.then(function () {
                  _this.onEvent({
                    action: 'Submit.Resolved'
                  });
                }).catch(function () {
                  _this.onEvent({
                    action: 'Submit.Rejected'
                  });
                });
              }
            };
          }
        }

        return crtToolbarProps;
      }
    };

    _this.state = {
      ready: false,
      submitting: false,
      submitted: false,
      saving: false,
      dirty: false,
      status: 'New'
    };
    _this.onLoaded = _this.onLoaded.bind(_assertThisInitialized(_this));
    _this.onEvent = _this.onEvent.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CommunicationFrame, [{
    key: "onLoaded",
    value: function onLoaded(data) {
      this.setState({
        ready: true
      });
      this.props.onLoaded && this.props.onLoaded(data);
    }
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      switch (event.action) {
        case 'Submit':
          this.setState({
            submitting: true
          });
          break;

        case 'Submit.Resolved':
          this.setState({
            submitting: false,
            dirty: false,
            status: getStatus(event.data && event.data.Stage)
          });
          this.props.onJobStarted && this.props.onJobStarted();
          break;

        case 'Submit.Rejected':
          this.setState({
            submitting: false
          });
          break;

        case 'Save':
          this.setState({
            saving: true
          });
          break;

        case 'Save.Resolved':
          this.setState({
            saving: false,
            dirty: false
          });
          break;

        case 'Save.Rejected':
          this.setState({
            saving: false
          });
          break;

        case 'JobCreated':
          this.setState({
            dirty: false,
            status: getStatus(event.data && event.data.Stage)
          });
          this.props.onJobCreated && this.props.onJobCreated(event.data);
          break;

        case 'JobFinished':
          this.setState({
            submitted: true,
            status: getStatus(event.data && event.data.Stage)
          });
          this.props.onJobFinished && this.props.onJobFinished(event.data);
          break;

        case 'JobLoaded':
          this.setState({
            status: getStatus(event.data && event.data.Stage)
          });
          this.props.onJobLoaded && this.props.onJobLoaded(event.data);
          break;

        case 'FormChanged':
          this.setState({
            dirty: true
          });
          this.props.onFormDataChanged && this.props.onFormDataChanged(event.data);
          break;

        case 'TemplateChanged':
          this.props.onTemplateChanged && this.props.onTemplateChanged(event.data);
          break;

        default:
          break;
      }
    }
    /**
     * @param {Partial<import('frame/FrameToolbar/types').FrameToolbarProps>} toolbarProps
     * @returns {import('frame/FrameToolbar/types').FrameToolbarProps}
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          projectName = _this$props.projectName,
          projectUid = _this$props.projectUid,
          jobId = _this$props.jobId,
          contactId = _this$props.contactId,
          hideFormNavigation = _this$props.hideFormNavigation,
          previewPath = _this$props.previewPath,
          height = _this$props.height,
          toolbarProps = _this$props.toolbarProps,
          hideToolBar = _this$props.hideToolBar,
          rest = _objectWithoutProperties(_this$props, ["projectName", "projectUid", "jobId", "contactId", "hideFormNavigation", "previewPath", "height", "toolbarProps", "hideToolBar"]);

      var _this$state2 = this.state,
          ready = _this$state2.ready,
          dirty = _this$state2.dirty;
      return React.createElement(React.Fragment, null, ready && React.createElement(BlockPrompt, {
        when: dirty
      }), React.createElement("div", {
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        }
      }, React.createElement(Grid, {
        container: true,
        direction: "column",
        style: {
          height: '100%'
        }
      }, ready && !hideToolBar && React.createElement(Grid, {
        item: true
      }, React.createElement(FrameToolbar, this.getToolbarProps(toolbarProps))), React.createElement(Grid, {
        item: true,
        xs: true,
        style: {
          position: 'relative'
        }
      }, React.createElement(FrameBase, Object.assign({}, rest, {
        useEcrionServer: true,
        url: getUrl(projectName, projectUid, jobId, contactId, hideFormNavigation, previewPath),
        namespace: "Communication",
        on: this.onEvent,
        onLoaded: this.onLoaded,
        ref: this.frame,
        height: height || 'auto'
      }))))));
    }
  }]);

  return CommunicationFrame;
}(React.Component);

CommunicationFrame.defaultProps = {
  height: '100%',
  style: {
    position: 'absolute',
    top: 0,
    left: 0,
    minHeight: 'auto'
  },
  hideToolBar: false
};
export default CommunicationFrame;